var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientFamilyFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 1.625H15.3181C15.4351 1.625 15.548 1.66863 15.6346 1.74738L20.346 6.03042C20.4441 6.11961 20.5 6.24604 20.5 6.37863V19.8068C20.5 21.2614 19.1667 21.625 18.5 21.625H6.5C4.9 21.625 4.5 20.4129 4.5 19.8068V3.44318C4.5 1.98864 5.83333 1.625 6.5 1.625ZM12.25 13.625C13.4926 13.625 14.5 12.6176 14.5 11.375C14.5 10.1324 13.4926 9.125 12.25 9.125C11.0074 9.125 10 10.1324 10 11.375C10 12.6176 11.0074 13.625 12.25 13.625ZM7.25 17.2078C7.25 15.6561 10.5813 14.8744 12.25 14.8744C13.9187 14.8744 17.25 15.6561 17.25 17.2078V18.3744H7.25V17.2078Z",
    fill: "#F1A809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientFamilyFile);
export default __webpack_public_path__ + "static/media/patient-family-file.c933f28fd6c80191cef8877bd7281f61.svg";
export { ForwardRef as ReactComponent };